import { isAfter, isBefore, isValid } from 'date-fns';
export const validateSelectedDate = ({ selectedDate, min, max }) => {
    if (!selectedDate || !isValid(selectedDate))
        return false;
    if (min && isBefore(selectedDate, min))
        return false;
    if (max && isAfter(selectedDate, max))
        return false;
    return true;
};
export const validateSelectedDateRange = ({ start, end, min, max }) => {
    if (!start || !end || !isValid(start) || !isValid(end))
        return false;
    if (isBefore(end, start))
        return false;
    if (min && (isBefore(start, min) || isBefore(end, min)))
        return false;
    if (max && (isAfter(start, max) || isAfter(end, max)))
        return false;
    return true;
};
export const getTodayDate = (mockDate) => mockDate || new Date();
export const getInitialActiveDate = ({ initialActiveDate, initialDate }) => {
    if (initialDate && isValid(initialDate))
        return initialDate;
    if (initialActiveDate && isValid(initialActiveDate))
        return initialActiveDate;
    const today = getTodayDate();
    let errorMessage = '';
    if (initialDate && !isValid(initialDate)) {
        errorMessage = 'initialDate is invalid.';
    }
    else if (initialActiveDate && !isValid(initialActiveDate)) {
        errorMessage = 'initialActiveDate is invalid.';
    }
    else if (initialDate || initialActiveDate) {
        errorMessage = 'Both initialActiveDate and initialDate are invalid.';
    }
    if (errorMessage) {
        console.error(`${errorMessage} Defaulting to today's date: ${today}`);
    }
    return today;
};
//# sourceMappingURL=date.logic.js.map